import React from "react";

import "./App.css"; // Import the CSS file


function App() {
  return (
    <div className="App">
      <center><img width="250px"
        className="centeredImage"
        src="https://img.squadhelp.com/story_images/visual_images/1651096986-DriverPass.png?class=show"
        alt="Your Image Description"
      /></center>
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js